<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">{{ queryparams()['organizer-type'] == 'appuntamenti' ? "Appuntamenti" : "Risorse" }}</h1>
                <p>Ci sono {{ getResources().length }} risorse registrate nel sistema</p>
                <button type="button" class="btn btn-primary" (click)="open()">Aggiungi</button>
            </div>
        </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-2" [hidden]="!getResources().length">
        <a class="navbar-brand">Visualizza</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar_type" aria-controls="navbar_type" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse flex-row justify-content-between" id="navbar_type">
            <ul class="nav nav-tabs">
                <li class="nav nav-tabs">
                    <a class="nav-link btn" 
                    [ngClass]="{'active': queryparams()['organizer-type'] == 'risorse'}"
                    [routerLink]="'/organizer'" 
                    [queryParams]="changeQueryParam({'organizer-type': 'risorse'})">Risorse</a>
                </li>
                <li class="nav nav-tabs">
                    <a class="nav-link btn" 
                    [ngClass]="{'active': queryparams()['organizer-type'] == 'appuntamenti'}"
                    [routerLink]="'/organizer'" 
                    [queryParams]="changeQueryParam({'organizer-type': 'appuntamenti'})">Appuntamenti</a>
                </li>
                <li class="nav nav-tabs">
                    <a class="nav-link btn" 
                    [ngClass]="{'active': queryparams()['organizer-type'] == 'waiting'}"
                    [routerLink]="'/organizer'" 
                    [queryParams]="changeQueryParam({'organizer-type': 'waiting'})">In attesa</a>
                </li>
            </ul>
        </div>
    </nav>

    <div [hidden]="!queryparams()['resource-selected'] || queryparams()['organizer-type'] != 'risorse'">
        <nav class="navbar navbar-expand-lg navbar-light bg-light mb-2">
            <a class="navbar-brand">Risorse</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar_resources" aria-controls="navbar_resources" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse flex-row justify-content-between" id="navbar_resources">
                <ul class="nav nav-tabs">
                    <li class="nav nav-tabs" *ngFor="let rule of getResources(); index as i">
                        <a class="nav-link btn" 
                        [ngClass]="{'active': queryparams()['resource-selected'] == rule.public_token}"
                        [routerLink]="'/organizer'" 
                        [queryParams]="changeQueryParam({'resource-selected': rule.public_token})">{{ rule.name || ''}}</a>
                    </li>
                </ul>
            </div>
        </nav>

        <div class="row mb-2">
            <div class="col">
                <form>
                    <div class="form-group row">
                        <label for="resource_name" class="col-sm-6 col-form-label">Nome della risorsa</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" id="resource_name" name="resource_name" placeholder="Nome della risorsa" [(ngModel)]="getResource().name">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="resource_time_value" class="col-sm-6 col-form-label">Durata temporale di ogni risorsa</label>
                        <div class="col-sm-6">
                            <input type="number" class="form-control" id="resource_time_value" name="resource_time_value" placeholder="Durata della risorsa" [(ngModel)]="getResource().configuration.availability.time.value">
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-6">La risorsa ha degli slot temporali</div>
                        <div class="col-sm-6">
                            <select class="custom-select" [(ngModel)]="getResource().configuration.availability.time.no_rules" id="no_rules" name="no_rules">
                                <option [ngValue]="false" [selected]="!getResource().configuration.availability.time.no_rules">S&igrave;</option>
                                <option [ngValue]="true" [selected]="!!getResource().configuration.availability.time.no_rules">No</option>
                            </select>
                        </div>
                    </div>


                    <div class="form-group row">
                        <div class="col-sm-6">La risorsa ha un numero limite utilizzabile contemporaneamente</div>
                        <div class="col-sm-6">
                            <select class="custom-select" [(ngModel)]="getResource().configuration.availability.quantity.value" id="no_rules" name="no_rules">
                                <option [ngValue]="1">S&igrave;</option>
                                <option [ngValue]="-1">No</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group row" [hidden]="getResource().configuration.availability.quantity.value < 0">
                        <label for="resource_quantity" class="col-sm-6 col-form-label">Quantit&agrave; di risorse disponibili contemporaneamente</label>
                        <div class="col-sm-6">
                            <input type="number" class="form-control" min="1" step="1" id="resource_quantity" name="resource_quantity" [(ngModel)]="getResource().configuration.availability.quantity.value">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="timestamp_before" class="col-sm-6 col-form-label">Minuti precedenti all'evento per la notifica di promemoria</label>
                        <div class="col-sm-6">
                            <input type="number" class="form-control" step="1" id="timestamp_before" name="timestamp_before" [(ngModel)]="getResource().configuration.timestamp_before">
                        </div>
                    </div>

                    <div class="form-check col-md-12 mb-2">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="getResource().configuration.user_bookable" id="user_bookable" name="user_bookable">
                        <label class="form-check-label" for="user_bookable">L'utente può richiedere un appuntamento per questa risorsa</label>
                    </div>

                    <button type="button" class="btn btn-danger" style="float: right;" (click)="openConfirm()">Elimina</button>
                    <button type="button" class="btn btn-primary" style="float: right; margin-right: 10px;" (click)="handleResource('updateresource')">Aggiorna</button>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col"><hr></div>
        </div>

        <div class="row mb-5 mt-2">
            <div class="col">

                <h1>Regole di disponibilità</h1>
                <button type="button" class="btn btn-primary" (click)="openRule()">Aggiungi</button>

                <div class="table-responsive-md mt-2" [hidden]="!getRules().length">
                    <table class="table">
                        <thead class="thead-primary">
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Data di inizio</th>
                                <th scope="col">Orari di inizio/fine</th>
                                <th scope="col">Giorno</th>
                                <th scope="col">Frequenza</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <a class="table-row" 
                                *ngFor="let rule of getRules(); index as i" 
                                [routerLink]="'/organizer'" 
                                [queryParams]="changeQueryParam({'rule-selected': rule.id})">
                                <td scope="col">{{ rule.id.substr(0, 5) }}</td>
                                <td scope="col">{{ formatDate(rule.start_timestamp) }}</td>
                                <td scope="col">{{ rule.from + " - " + rule.to }}</td>
                                <td scope="col">{{ getFormattedFrequency(rule, 'day') }}</td>
                                <td scope="col">{{ getFormattedFrequency(rule, 'frequency') }}</td>
                                <td scope="col">{{ getFormattedFrequency(rule, 'week') }}</td>
                            </a>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div [hidden]="!queryparams()['resource-selected'] || queryparams()['organizer-type'] != 'appuntamenti'">
        <div class="row mt-5">
            <div class="col">
                
                <div class="calendar">
                    <header>
                        <h2>{{ getMonth() }}</h2>
                        <a class="btn-prev fontawesome-angle-left" 
                        [routerLink]="'/organizer'" 
                        [queryParams]="changeQueryParam({'organizer-calendar': getCurrent().add(-1, 'month').valueOf() })">&#8592;</a>
    
                        <a class="btn-next fontawesome-angle-right" 
                        [routerLink]="'/organizer'" 
                        [queryParams]="changeQueryParam({'organizer-calendar': getCurrent().add(1, 'month').valueOf() })">&#8594;</a>
                    </header>
                    <table class="calendar-table">
                        <thead>
                            <tr>
                                <td>Lun</td>
                                <td>Mar</td>
                                <td>Mer</td>
                                <td>Gio</td>
                                <td>Ven</td>
                                <td>Sab</td>
                                <td>Dom</td>
                            </tr>
                        </thead>
    
                        <tbody>
    
                            <tr *ngFor="let week of getCurrentMonth(); index as i">
                                <td *ngFor="let day of week; index as i"
                                (click)="!!day.number && setCurrentDay(day.day)" 
                                [ngClass]="getCellClass(day)">
                                    {{ day.number || '' }}
                                </td>
                            </tr>
    
                        </tbody>
    
                    </table>
    
                </div>
    
            </div>
        </div>

        <div class="row mt-4">
            <ul [hidden]="!getCurrentAppuntamenti().length" class="list-group list-group-flush col-12">
                <li class="list-group-item"><h4>Eventi in programma</h4></li>
        
                <li class="list-group-item" *ngFor="let ev of getCurrentAppuntamenti(); index as i">
                    <i slot="start" name="fas fa-calendar"></i>
                    <h5><span *ngFor="let target of getTargetsEvent(ev.configuration.boocal.targets); index as j">{{ (j > 0 ? ' - ' : '') + window.usher.getChildren(target)?.public_configuration?.nome }}</span></h5>
                    <p class="ml-2"><b>{{ ev.name }}</b></p>
                    <p class="ml-2">{{ ev.configuration.note }}</p>
                    <p class="ml-2">{{ formatDateTime(ev.start_timestamp) }}</p>
                </li>
            </ul>
        </div>
    </div>

    <div [hidden]="!queryparams()['resource-selected'] || queryparams()['organizer-type'] != 'waiting'">
        <div class="row mt-4">
            <div class="col-md-4 col-sm-6" *ngFor="let ev of getCurrentAppuntamenti(); index as i">
                <div class="card">
                    <div class="card-header">{{ ev.configuration.boocal.resource_name }}</div>
                    <div class="card-body">
                        <h5 class="card-title">{{ ev.name }}</h5>
                        <p>{{ window.usher.getChildren(ev.configuration.boocal.owner)?.public_configuration?.nome }}</p>
                        <p class="card-text">{{ ev.configuration.note }}</p>
                        <p>{{ formatDateTime(ev.start_timestamp) }}</p>
                        <button class="btn btn-primary mr-1" (click)="handleBoocal(ev, 'accept')">Accetta</button>
                        <button class="btn btn-danger ml-1" (click)="handleBoocal(ev, 'deny')">Rifiuta</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<span id="newResourceModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Aggiungi risorsa</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_resource_name">Nome della risorsa</label>
                            <input type="text" class="form-control" id="modal_resource_name" name="modal_resource_name" placeholder="Nome della risorsa" [(ngModel)]="resource_model.name">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_resource_time_value">Tempo occupato dalla singola risorsa (es.: 45 min)</label>
                            <input type="number" min="1" step="1" class="form-control" id="modal_resource_time_value" name="modal_resource_time_value" placeholder="Durata della risorsa" [(ngModel)]="resource_model.configuration.availability.time.value">
                        </div>
                    </div>

                    <!--<div class="form-row">-->
                        <div class="form-check col-md-12 mb-2">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="resource_model.configuration.availability.time.no_rules" id="modal_no_rules" name="modal_no_rules">
                            <label class="form-check-label" for="modal_no_rules">La risorsa ha degli slot temporali</label>
                        </div>
                    <!--</div>-->

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_quantity_no_rules">La risorsa ha risorse disponibili contemporaneamente</label>
                            <select class="custom-select" [(ngModel)]="resource_model.configuration.availability.quantity.value" id="modal_quantity_no_rules" name="modal_quantity_no_rules">
                                <option [ngValue]="1">S&igrave;</option>
                                <option [ngValue]="-1">No</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="form-row" [hidden]="resource_model.configuration.availability.quantity.value < 0">
                        <div class="form-group col-md-12">
                            <label for="modal_resource_quantity">Risorse disponibili contemporaneamente</label>
                            <input type="number" class="form-control" id="modal_resource_quantity" min="1" step="1" name="modal_resource_quantity" [(ngModel)]="resource_model.configuration.availability.quantity.value">
                        </div>
                    </div>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="handleResource('newresource')">Aggiungi</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>

<span id="deleteResourceModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Elimina</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeConfirm()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                Sei sicuro di voler eliminare questa risorsa?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="deleteResource()">Elimina</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeConfirm()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>

<span id="ruleModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Aggiungi regola</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeRule()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_rule_start">Inizio validità</label>
                            <input type="date" class="form-control" id="modal_rule_start" name="modal_rule_start" placeholder="Inizio validità" [(ngModel)]="getRule().start_timestamp">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_rule_time_from">Inizio della regola (es.: Dalle 12:00)</label>
                            <input type="time" class="form-control" id="modal_rule_time_from" name="modal_rule_time_from" placeholder="Inizio della regola" [(ngModel)]="getRule().from">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_rule_slot">Fine della regola</label>
                            <select class="custom-select" [(ngModel)]="temp_slot.value" id="modal_rule_slot" name="modal_rule_slot" (change)="onRuleChange($event)">
                                <option [ngValue]="resource_number" *ngFor="let resource_number of getResourceQuantity(); index as i">{{ calculateTo(resource_number) }}</option>
                            </select>
                        </div>
                    </div>

                    <!--<div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_rule_time_to">Fine della regola</label>
                            <span type="time" class="form-control" id="modal_rule_time_to" name="modal_rule_time_to" placeholder="Fine della regola">{{ getRule().to }}</span>
                        </div>
                    </div>-->
                    
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_rule_frequency">Frequenza (es.: Singola, Settimanale, Bisettimanale, Mensile, Annuale)</label>
                            <select class="custom-select" [(ngModel)]="getRule().frequency" id="modal_rule_frequency" name="modal_rule_frequency">
                                <option value="una-tantum">Singola</option>
                                <option value="weekly">Settimanale</option>
                                <option value="biweekly">Bisettimanale</option>
                                <option value="monthly">Mensile</option>
                                <option value="annually">Annuale</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row" [hidden]="getRule().frequency == 'una-tantum' || getRule().frequency == 'annually'">
                        <div class="form-group col-md-12">
                            <label for="modal_rule_day">Giorno della settimana</label>
                            <select class="custom-select" [(ngModel)]="getRule().day" id="modal_rule_day" name="modal_rule_day">
                                <option value="0">Lunedì</option>
                                <option value="1">Martedì</option>
                                <option value="2">Mercoledì</option>
                                <option value="3">Giovedì</option>
                                <option value="4">Venerdì</option>
                                <option value="5">Sabato</option>
                                <option value="6">Domenica</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row" [hidden]="getRule().frequency != 'biweekly'">
                        <div class="form-group col-md-12">
                            <label for="modal_rule_week">Cadenza della settimana</label>
                            <select class="custom-select" [(ngModel)]="getRule().week" id="modal_rule_week" name="modal_rule_week">
                                <option value="0">Settimane pari</option>
                                <option value="1">Settimane dispari</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row" [hidden]="getRule().frequency != 'monthly'">
                        <div class="form-group col-md-12">
                            <label for="modal_rule_week2">Cadenza della settimana</label>
                            <select class="custom-select" [(ngModel)]="getRule().week" id="modal_rule_week2" name="modal_rule_week2">
                                <option value="0">Prima settimana</option>
                                <option value="1">Seconda settimana</option>
                                <option value="2">Terza settimana</option>
                                <option value="3">Quarta settimana</option>
                                <option value="4">Quinta settimana</option>
                            </select>
                        </div>
                    </div>

                </form>

            </div>
            <div class="modal-footer"><button type="button" class="btn btn-primary" (click)="handleRule()">{{ queryparams()['rule-selected'] ? 'Aggiorna' : 'Aggiungi' }}</button>
                <button type="button" class="btn btn-danger" [hidden]="!queryparams()['rule-selected']" (click)="deleteRule()">Elimina</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeRule()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>

<span id="newAppuntamentoModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Aggiungi appuntamento</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_resource_name">Nome dell&rsquo;appuntamento</label>
                            <input type="text" class="form-control" id="appuntamento_name" name="appuntamento_name" placeholder="Nome dell'appuntamento" [(ngModel)]="getAppuntamento().name">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_resource_time_value">Note</label>
                            <textarea rows="3" class="form-control" name="appuntamento_note" id="appuntamento_note" [(ngModel)]="getAppuntamento().configuration.note"></textarea>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="start_data">Data e Ora</label>
                            <input class="form-control" title="Data e Ora" type="datetime-local" [value]="formatDateTime(getAppuntamento().start_timestamp, 'yyyy-MM-DDTHH:mm')" (change)="updateDateTime($event)" name="start_data" id="start_data">
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="modal_resource_time_value">Risorsa</label>
                            <select name="resource_appuntamento" class="form-control" id="resource_appuntamento" [(ngModel)]="getAppuntamento().configuration.boocal.resource">
                                <option *ngFor="let resource of getResources(); index as i" [value]="resource.public_token">{{ resource.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" id="isprivate_group" name="isprivate_group" (change)="setAppuntamentoPrivateGroup($event)" [(ngModel)]="getAppuntamento().configuration.boocal.private_group">
                                <label class="form-check-label" for="isprivate_group">L&apos;appuntamento verr&agrave; fissato per tutti gli utenti</label>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="type">Aggiungi utente</label>
                            <select name="user_select" id="user_select" class="form-control" (change)="addAppuntamentoUser($event)">
                                <option value="">-</option>
                                <option [value]="user.public_token"[selected]="getAppuntamento().configuration.boocal.targets[getAppuntamento().configuration.boocal.targets.length-1] == user.public_token" *ngFor="let user of window.usher.getChildren(); index as i">{{ user.public_configuration?.nome }}</option>
                            </select>
                        </div>
                        <!--<div class="form-group col-md-6">
                            <label for="type">Scegli gruppo</label>
                            <select name="group_select" id="group_select" class="form-control" (change)="addAppuntamentoGroup($event)">
                                <option value="">-</option>
                                <option [value]="group.id" [selected]="getAppuntamento().configuration.boocal.group == group.id" *ngFor="let group of window.usher.get()?.public_configuration?.groups; index as i">{{ group.name }}</option>
                            </select>
                        </div>-->
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <ul>
                                <li *ngFor="let user_pt of getAppuntamento().configuration.boocal.targets; index as i">{{ window.usher.getChildren(user_pt)?.public_configuration?.nome }}<span (click)="getAppuntamento().configuration.boocal.targets.splice(i, 1)" class="float-right cursor-pointer"><i class="fas fa-trash"></i></span></li>
                            </ul>
                        </div>
                    </div>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="addBoocal()">Aggiungi</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>